import ChartTemplate from "@/components/chart-template";
import { RevenueOverviewRow } from "@/http/api-types";
import { last12Months } from ".";
import RevenueOverviewChart from "./revenue-overview-chart";

type RevenueChartProps = {
  data: RevenueOverviewRow[];
};

function RevenueOverview({ data }: RevenueChartProps) {
  const trailing_start_index = 12;
  const chartData = data
    .filter(row => last12Months().includes(row.month_year) && row.query_period === "all_days")
    .map((row, index) => {
      return {
        ...row,
        dateTime: new Date(row.month_year).toLocaleDateString("en-US", {
          month: "short",
          year: "numeric",
        }),
        trailingRevenue:
          data.slice(index, index + trailing_start_index).reduce((acc, row) => {
            return acc + row.revenue;
          }, 0) / 12,
      };
    });

  return (
    <ChartTemplate
      timeSplittable={false}
      summaryMetric=""
      summaryMetricLabel=""
      title="Revenue Overview"
      description="Compared to last 12 months trailing revenue"
      chart={<RevenueOverviewChart chartData={chartData} />}
      table={null}
    ></ChartTemplate>
  );
}

export default RevenueOverview;
